
const digest = 'd591101ea60079411ff826d7cfcffdf59dbbebeb63ec4b863303a35c52a8aa3b';
const classes = {"detailTableWrapper":"_detailTableWrapper_w95qq_1"};
const css = `._detailTableWrapper_w95qq_1 table tbody tr td:first-child {
  display: grid;
  grid-template-columns: minmax(200px, auto) 1fr;
  gap: 0 16px;
}
._detailTableWrapper_w95qq_1 table tbody tr td:first-child > div {
  min-width: 0;
}
._detailTableWrapper_w95qq_1 table tbody tr td:first-child > div:last-child {
  justify-content: flex-start;
  overflow-wrap: break-word;
  word-break: break-word;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  